// extracted by mini-css-extract-plugin
export default {"routeTitleContainer":"Title_routeTitleContainer__miJOm","col":"Title_col__R3VsK","routeTitle":"Title_routeTitle__+EU8s","deleteIconCol":"Title_deleteIconCol__mbk1p"};